import { ColorEnum } from '@enum/style/color.enum';

import { StepsStyleType } from './steps-style.type';

export const StepsDarkTheme: StepsStyleType = {
  iconSize: 24,

  colorPrimary: ColorEnum.Teal100,
  colorText: ColorEnum.Black3,
  colorTextDescription: ColorEnum.Black80,
  colorSplit: ColorEnum.Black80,
  colorTextLightSolid: ColorEnum.Black3,
  controlItemBgActive: ColorEnum.IndicationSuccess100,
  colorTextLabel: ColorEnum.Black80,
  colorFillContent: ColorEnum.Black90,
};
